import { Link } from 'react-router-dom';
import { categories } from '@/mocks/qieziData';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索精彩内容
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            从搞笑日常到才艺表演，从美食烹饪到旅行风光，总有你喜欢的内容
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?cat=${cat.id}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 cursor-pointer transition-all duration-200"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${cat.color} flex items-center justify-center text-white`}>
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-500 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}个视频</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}